import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import ExpansionRevenueOvertakeNetWorth from '../components/ExpansionRevenueOvertakeNetWorth'
export default function WillExpansionRevenueOvertakNetNewAcquisitionIn2026() {
  return (
    <div>
<Header1/>
<ExpansionRevenueOvertakeNetWorth/>
<Footer/>
    </div>
  )
}
